/**
 * @generated SignedSource<<f2e95f681ac6b20db00520ffb06b55f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableHeader_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_user">;
  readonly " $fragmentType": "PdpRespUnavailableHeader_user";
};
export type PdpRespUnavailableHeader_user$key = {
  readonly " $data"?: PdpRespUnavailableHeader_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableHeader_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableHeader_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0125f79dec375b5f1ee5775222bee1a2";

export default node;
